import * as React from 'react';
import { map } from 'lodash';
import { Link } from 'react-router-dom';
import {Field, FieldArray, reduxForm, formValueSelector} from "redux-form";
import { connect } from 'react-redux';
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent';
import { withStyles } from '@material-ui/core/styles';
import Select from '@material-ui/core/NativeSelect';
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
import CancelIcon from '@material-ui/icons/Cancel'
import renderField from "../../onboarding/Form";
import ColorPicker from './ColorPicker';
import CampaignUploadInput from './CampaignUploadInput'

const floatingButtonWidgetTypes =
  [
    { name: 'With info', value: 'float_info' },
    { name: 'Without info', value: 'float_no_info' },
  ];
const inTextWidgetTypes = [
  { name: 'Tag-line, info and then amount', value: 'tagline_info_amount' },
  { name: 'Tag-line then amount', value: 'tagline_amount' },
  { name: 'Without tag-line, info and amount', value: 'info_amount' },
  { name: 'Without tag-line, just amount', value: 'amount' }
];
const styles = {
  widgetTypeHeader: {
    fontSize: 18,
    fontWeight: '600px !important',
    color: '#000 !important',
    textDecoration: 'underline'
  },
  optionContainer: {
    paddingLeft: 15
  }
};
const stylesMUI ={
  flex: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  giftBtn:{
    // width: '48%',
    padding: 10,
    borderBottom: '2px solid #ececec'
  },
  input: {
    width: '48%',
    marginBottom: 40
  },
  inputMargin: {
    marginBottom: 40
  },
  paymentCard: {
    padding: 20,
    background: '#f3f3f3',
    marginBottom: 10
  },
  panelBg: {
    backgroundColor: '#f3f3f3'
  },
  paddingTop: {
    paddingTop:20
  },
  colorPickerLabel: {
    paddingBottom: 10
  }
}

const renderSelectField = ({
  input,
  children,
  ...custom
}) => (
  <Select {...input} children={children} {...custom} className="input-border" />
);

const renderColorPicker = ({
  input,
  label,
  meta: { touched, error },
  children,
  ...custom
}) => (
  <ColorPicker
    {...input}
    children={children}
    {...custom}
  />
)

const campaignTypeConfig = {
  donation: {
    thankYouMessage: { maxLength: 370, required: true },
    optInStatement: { required: true },
    consent: { required: true },
    includeTargetOption: true,
    giftAidOption: true,
    payments: true
  },
  petition: {
    thankYouMessage: { maxLength: 370, required: true },
    petitionOptInStatement: { required: true },
    consent: { required: true },
    includePetitionTargetOption: true,
  },
  fundraisingPack: {
    ctaText: { maxLength: 30, required: false },
    title2: { maxLength: 50, required: true },
    description2: { maxLength: 270, required: true },
    skipLandingStepOption: true,
    fundraisingPackConsentText: { maxLength: 50, required: true },
    fundraisingPackSidePanelTitle: { maxLength: 50, required: true }, 
    fundraisingPackSidePanelButtonText: { maxLength: 20, required: true }, 
    fundraisingPackConsentCheckboxText: { maxLength: 50 },
    fundraisingPackConsentIsOptionalOption: true,
    fundraisingPackConsentStatement1: { required: true },
    fundraisingPackConsentStatement2: { required: true },
    thankYouMessage: { maxLength: 370, required: true },
    thanksEmail: true
  },
  poll: {
    ctaText: { maxLength: 30 },
    pollAnswerText: { maxLength: 270, required: true },
    pollAnswers: true,
    title2: { maxLength: 50 },
    description2: { maxLength: 270 }, 
    consent: { maxLength: 50 },
    optInStatement: { maxLength: 200 },
    thankYouHeading: { maxLength: 50 },
    thankYouMessage: { maxLength: 370 },
    thanksEmail: true
  }
}

const CampaignFormComponent: React.SFC<any> = (props: any) => {
  const {
    error,
    pristine,
    handleSubmit,
    submitting,
    charities,
    classes,
    auth,
    includeTarget,
    campaignType,
    description,
    description2,
    oneOffPayments,
    monthlyPayments,
    title,
    title2,
    ctaText,
    mission,
    thankYouHeading,
    thankYouMessage,
    sidePanelFacts,
    pollAnswers,
    sidePanelFooter,
    includePetitionTarget,
    fundraisingPackConsentText,
    fundraisingPackSidePanelTitle,
    fundraisingPackSidePanelButtonText,
    fundraisingPackConsentCheckboxText,
    fundraisingPackConsentIsOptional,
    pollAnswerText
  } = props;
  const required = value => value ? undefined : 'Required';
  // convert and populate the payments data
  const fieldConfig = campaignType ? campaignTypeConfig[campaignType] : { };

  return (
    <Card>
      <CardContent>
        <form onSubmit={handleSubmit}>
          <div className={classes.flex}>
            <div className={classes.input}>
              <Field
                component={renderField}
                type="text"
                placeholder="Name"
                label="Name"
                name="name"
                validate={[ required ]}
              />
            </div>
            <div className={classes.input}>
              <Field
                placeholder="Charity Mission"
                label="Charity Mission"
                name="mission"
                inputProps={{
                  maxLength: 250
                }}
                FormHelperTextProps={{
                  style: {textAlign: 'right'}
                }}
                helperText={`${mission && mission.length || 0} / 250`}
                type="text"
                component={renderField}
              />
            </div>
          </div>
          <div className={classes.flex}>
            <div className={classes.input}>
              <Field
                component={renderField}
                type="text"
                placeholder="Title"
                label="Title"
                name="title"
                inputProps={{
                  maxLength: campaignType === 'poll' ? 100 : 50
                }}
                FormHelperTextProps={{
                  style: {textAlign: 'right'}
                }}
                helperText={`${title && title.length || 0} / 50`}
                validate={[ required ]}
              />
            </div>
            <div className={classes.input}>
              <InputLabel>Campaign Type</InputLabel>
              <div className="control">
                <Field name="campaignType" component={renderSelectField}>
                  <option value="">Please Select</option>
                  <option value="donation">Donation</option>
                  <option value="petition">Petition</option>
                  <option value="volunteering">Volunteering</option>
                  <option value="fundraisingPack">Fundraising Pack</option>
                  <option value="poll">Poll</option>
                </Field>
                {error && <p className="help is-danger">{error}</p>}
              </div>
            </div>
          </div>
          <div className={classes.flex}>
            {campaignType !== 'fundraisingPack' &&
              <div  className={classes.input}>
                <InputLabel>Widget Type</InputLabel>
                <div className="control">
                  <Field name="widgetType" component={renderSelectField}>
                    <option value="">Please select</option>
                    <option style={styles.widgetTypeHeader} disabled={true}>Floating Button</option>
                    {
                      map(floatingButtonWidgetTypes, (type: any, key: string) => (
                        <option key={key} value={type.value} style={styles.optionContainer}>{type.name}</option>
                      ))
                    }
                    <option style={styles.widgetTypeHeader} disabled={true}>In-Text</option>
                    {
                      map(inTextWidgetTypes, (type: any, key: string) => (
                        <option key={key} value={type.value} style={styles.optionContainer}>{type.name}</option>
                      ))
                    }
                  </Field>
                </div>
              </div>
            }
            {auth.isAdmin && <div className={classes.input}>
              <InputLabel>Select charity</InputLabel>
              <div className="control">
                <Field name="charity" component={renderSelectField}>
                  <option value="">Please select</option>
                  {
                    map(charities, (charity: any, charityId: string) => (
                      <option key={charityId} value={charityId} style={styles.optionContainer}>{charity.name}</option>
                    ))
                  }
                </Field>
                {error && <p className="help is-danger">{error}</p>}
              </div>
            </div>}
          </div>
          <div className={classes.inputMargin}>
            <Field
              type="textarea"
              component={renderField}
              label="Description"
              name="description"
              inputProps={{
                maxLength: 270
              }}
              FormHelperTextProps={{
                style: {textAlign: 'right'}
              }}
              helperText={`${description && description.length || 0} / 270`}
              validate={[ required ]}
            />
          </div>

          {fieldConfig.ctaText &&
            <div className={classes.input}>
              <Field
                component={renderField}
                type="text"
                placeholder="Enter text..."
                label="CTA Text"
                name="ctaText"
                inputProps={{
                  maxLength: fieldConfig.ctaText.maxLength
                }}
                FormHelperTextProps={{
                  style: {textAlign: 'right'}
                }}
                helperText={`${ctaText && ctaText.length || 0} / ${fieldConfig.ctaText.maxLength}`}
                validate={fieldConfig.ctaText.required ? [ required ] : undefined}
              />
            </div>
          }
          {fieldConfig.skipLandingStepOption &&
            <div className={classes.input}>
              <FormControlLabel control={
                <Field
                  name="skipLandingStep"
                  component={renderField}
                  type="checkbox"
                />}
                label="Skip Landing Step"
              />
            </div>
          }
          
          {fieldConfig.pollAnswerText &&
            <div className={classes.inputMargin}>
              <Field
                type="textarea"
                component={renderField}
                label="Poll answer text"
                name="pollAnswerText"
                inputProps={{
                  maxLength: 270
                }}
                FormHelperTextProps={{
                  style: {textAlign: 'right'}
                }}
                helperText={`${pollAnswerText && pollAnswerText.length || 0} / 270`}
                validate={[ required ]}
              />
          </div>
          }

          {fieldConfig.title2 &&
            <div className={classes.input}>
              <Field
                component={renderField}
                type="text"
                placeholder="Enter title..."
                label="Title 2"
                name="title2"
                inputProps={{
                  maxLength: fieldConfig.title2.maxLength
                }}
                FormHelperTextProps={{
                  style: {textAlign: 'right'}
                }}
                helperText={`${title2 && title2.length || 0} / ${fieldConfig.title2.maxLength}`}
                validate={fieldConfig.title2.required ? [ required ] : undefined}
              />
            </div>
          }

          {fieldConfig.description2 &&
            <div className={classes.inputMargin}>
              <Field
                type="textarea"
                component={renderField}
                label="Description 2"
                placeholder="Enter description..."
                name="description2"
                inputProps={{
                  maxLength: fieldConfig.description2.maxLength
                }}
                FormHelperTextProps={{
                  style: {textAlign: 'right'}
                }}
                helperText={`${description2 && description2.length || 0} / ${fieldConfig.description2.maxLength}`}
                validate={fieldConfig.description2.required ? [ required ] : undefined}
              />
            </div>
          }

          {fieldConfig.fundraisingPackConsentText &&
            <div className={classes.input}>
              <Field
                component={renderField}
                type="text"
                placeholder="Enter consent text..."
                label="Fundraising Pack Consent Text"
                name="fundraisingPackConsentText"
                inputProps={{
                  maxLength: fieldConfig.fundraisingPackConsentText.maxLength
                }}
                FormHelperTextProps={{
                  style: {textAlign: 'right'}
                }}
                helperText={`${fundraisingPackConsentText && fundraisingPackConsentText.length || 0} / ${fieldConfig.fundraisingPackConsentText.maxLength}`}
                validate={fieldConfig.fundraisingPackConsentText.required ? [ required ] : undefined}
              />
            </div>
          }

          {fieldConfig.fundraisingPackSidePanelTitle &&
            <div className={classes.input}>
              <Field
                component={renderField}
                type="text"
                placeholder="Enter title..."
                label="Fundraising Pack Side Panel Title"
                name="fundraisingPackSidePanelTitle"
                inputProps={{
                  maxLength: fieldConfig.fundraisingPackSidePanelTitle.maxLength
                }}
                FormHelperTextProps={{
                  style: {textAlign: 'right'}
                }}
                helperText={`${fundraisingPackSidePanelTitle && fundraisingPackSidePanelTitle.length || 0} / ${fieldConfig.fundraisingPackSidePanelTitle.maxLength}`}
                validate={fieldConfig.fundraisingPackSidePanelTitle.required ? [ required ] : undefined}
              />
            </div>
          } 

          {fieldConfig.fundraisingPackSidePanelButtonText &&
            <div className={classes.input}>
              <Field
                component={renderField}
                type="text"
                placeholder="Enter button text..."
                label="Fundraising Pack Side Panel Button Text"
                name="fundraisingPackSidePanelButtonText"
                inputProps={{
                  maxLength: fieldConfig.fundraisingPackSidePanelButtonText.maxLength
                }}
                FormHelperTextProps={{
                  style: {textAlign: 'right'}
                }}
                helperText={`${fundraisingPackSidePanelButtonText && fundraisingPackSidePanelButtonText.length || 0} / ${fieldConfig.fundraisingPackSidePanelButtonText.maxLength}`}
                validate={fieldConfig.fundraisingPackSidePanelButtonText.required ? [ required ] : undefined}
              />
            </div>
          } 

          {fieldConfig.fundraisingPackConsentCheckboxText &&
            <div className={classes.input}>
              <Field
                type="textarea"
                component={renderField}
                label="Consent Checkbox Text"
                name="fundraisingPackConsentCheckboxText"
                helperText={`${fundraisingPackConsentCheckboxText && fundraisingPackConsentCheckboxText.length || 0} / ${fieldConfig.fundraisingPackConsentCheckboxText.maxLength}`}
                validate={fieldConfig.fundraisingPackConsentCheckboxText.required ? [ required ] : undefined}
              />
            </div>
          }

          {fieldConfig.fundraisingPackConsentIsOptionalOption &&
            <div className={classes.input}>
              <FormControlLabel control={
                <Field
                  name="fundraisingPackConsentIsOptional"
                  component={renderField}
                  type="checkbox"
                />}
                label="Consent is optional"
              />
            </div>
          }

          {fieldConfig.fundraisingPackConsentStatement1 &&
            <div className={classes.input}>
              <Field
                component={renderField}
                type="textarea"
                placeholder="Opt In Statement"
                label="Consent Statement 1"
                name="fundraisingPackConsentStatement1"
                validate={fieldConfig.fundraisingPackConsentStatement1.required ? [ required ] : undefined}
              />
            </div>
          }

          {fieldConfig.fundraisingPackConsentStatement2 &&
            <div className={classes.input}>
              <Field
                component={renderField}
                type="textarea"
                placeholder="Opt In Statement"
                label="Consent Statement 2"
                name="fundraisingPackConsentStatement2"
                validate={fieldConfig.fundraisingPackConsentStatement2.required ? [ required ] : undefined}
              />
            </div>
          }
                    
          {campaignType !== 'fundraisingPack' && campaignType !== 'poll' &&
            <FieldArray name="sidePanelFacts" component={renderSidePanelFacts} classes={classes} sidePanelFacts={sidePanelFacts} sidePanelFooter={sidePanelFooter} />
          }

          {fieldConfig.pollAnswers &&
            <FieldArray name="pollAnswers" component={renderPollAnswers} classes={classes} pollAnswers={pollAnswers}  />
          }

          {fieldConfig.thankYouHeading &&
            <div className={classes.input}>
              <Field
                component={renderField}
                type="text"
                placeholder="Enter heading"
                label="Thank You Heading"
                name="thankYouHeading"
                inputProps={{
                  maxLength: fieldConfig.thankYouHeading.maxLength
                }}
                FormHelperTextProps={{
                  style: {textAlign: 'right'}
                }}
                helperText={`${thankYouHeading && thankYouHeading.length || 0} / ${fieldConfig.thankYouHeading.maxLength}`}
                validate={fieldConfig.thankYouHeading.required ? [ required ] : undefined}
              />
            </div>
          }

          {fieldConfig.thankYouMessage &&
            <div className={classes.inputMargin}>
              <Field
                type="textarea"
                component={renderField}
                label="Thank You Message"
                name="thankYouMessage"
                inputProps={{
                  maxLength: fieldConfig.thankYouMessage.maxLength
                }}
                FormHelperTextProps={{
                  style: {textAlign: 'right'}
                }}
                helperText={`${thankYouMessage && thankYouMessage.length || 0} / ${fieldConfig.thankYouMessage.maxLength}`}
              />
            </div>
          }

          {fieldConfig.thanksEmail &&
            <React.Fragment>
              <div className={classes.input}>
                <Field
                  component={renderField}
                  type="text"
                  label="Thanks Email Subject"
                  placeholder="The subject line of your thanks email"
                  name="thanksEmailSubject"
                />
              </div>
              <div className={classes.inputMargin}>
                <Field
                  type="textarea"
                  component={renderField}
                  label="Thanks Email Html"
                  placeholder="Html markup for your thanks email"
                  name="thanksEmailHtml"
                />
              </div>
              <div className={classes.inputMargin}>
                <Field
                  type="textarea"
                  component={renderField}
                  label="Thanks Email Plain Text Version"
                  placeholder="text for your thanks email"
                  name="thanksEmailText"
                />
              </div>
              <div className={classes.input}>
                <Field
                  component={renderField}
                  type="text"
                  placeholder="The name your thanks email will be sent from"
                  label="Thanks Email From"
                  name="thanksEmailFrom"
                />
              </div>
            </React.Fragment>
          }

          
         
         
      
            {campaignType === 'donation' && auth.isAdmin && 
              <div className={classes.input}>
                <Field
                  type="input"
                  component={renderField}
                  label="Donaco Commission"
                  name="stripeFeePercentage"
                  validate={[ required ]}
                  placeholder="e.g. 4"
                />
              </div>
            }

            {fieldConfig.optInStatement &&
              <div className={classes.input}>
                <Field
                  component={renderField}
                  type="text"
                  placeholder="Opt In Statement"
                  label="Opt In Statement"
                  name="optInStatement"
                  validate={fieldConfig.optInStatement.required ? [ required ] : undefined}
                />
              </div>
            }
            
            {fieldConfig.petitionOptInStatement && 
              <div className={classes.input}>
                <Field
                  component={renderField}
                  type="text"
                  placeholder="Opt In Statement"
                  label="Opt In Statement"
                  name="petitionOptInStatement"
                  validate={fieldConfig.petitionOptInStatement.required ? [ required ] : undefined}
                />
              </div>
            }

          
          {fieldConfig.consent &&
            <div className={classes.inputMargin}>
              <Field
                type="textarea"
                component={renderField}
                label="Opt In Consent Statement"
                name="consent"
              />
            </div>
          }

          {fieldConfig.includeTargetOption && 
            <div className={classes.flex}>
              <div className={classes.input}>
                <FormControlLabel control={
                  <Field
                    name="includeTarget"
                    component={renderField}
                    type="checkbox"
                  />}
                  label="Include Target"
                />
              </div>
              {includeTarget && 
                <div className={classes.input}>
                  <Field
                    component={renderField}
                    type="text"
                    placeholder="Target"
                    label="Target"
                    name="target"
                  />
                </div>
              }
            </div> 
          }

          {fieldConfig.includePetitionTarget && 
            <div className={classes.flex}>
              <div className={classes.input}>
                <FormControlLabel control={
                  <Field
                    name="includePetitionTarget"
                    component={renderField}
                    type="checkbox"
                  />}
                  label="Include Target"
                />
              </div>
              {includePetitionTarget && 
                <div className={classes.input}>
                  <Field
                    component={renderField}
                    type="text"
                    placeholder="Target"
                    label="Target"
                    name="petitionTarget"
                  />
                </div>
              }
            </div> 
          }

          {fieldConfig.giftAidOption && 
            <div className="field">
              <FormControlLabel control={
                <Field
                  name="giftAidOption"
                  component={renderField}
                  type="checkbox"
                />}
                label="Include Gift Aid"
                />
            </div>
          }

          {fieldConfig.payments && 
            <div className={classes.flex}>
              <div className={classes.input}>
                <FieldArray name="oneOffPayments" component={renderOneOffPayments} classes={classes} oneOffPayments={oneOffPayments}/>
              </div>
              <div className={classes.input}>
                <FieldArray name="monthlyPayments" component={renderMonthlyPayments} classes={classes} monthlyPayments={monthlyPayments} />
              </div>
            </div>
          }

          <div className={classes.flex}>
            <div className={classes.input}>
              <InputLabel className={classes.colorPickerLabel}>Topbar Color</InputLabel>
              <Field
                component={renderColorPicker}
                label="Topbar Color"
                name="topbarColor"
                validate={[ required ]}
                placeholder="e.g. #e90e0e"
              />
            </div>
            <div className={classes.input}>
              <InputLabel className={classes.colorPickerLabel}>Text Color</InputLabel>
              <Field
                component={renderColorPicker}
                label="Text Color"
                name="textColor"
                validate={[ required ]}
                placeholder="e.g. #777777"
              />
            </div>
          </div>
          <div className={classes.flex}>
            <div className={classes.input}>
              <InputLabel className={classes.colorPickerLabel}>Heading Color</InputLabel>
              <Field
                component={renderColorPicker}
                label="Heading Color"
                name="headingColor"
                placeholder="e.g. #777777"
              />
            </div>
            <div className={classes.input}>
              <InputLabel className={classes.colorPickerLabel}>Heading Highlight Color</InputLabel>
              <Field
                component={renderColorPicker}
                label="Heading Highlight Color"
                name="headingHighlightColor"
                placeholder="e.g. #777777"
              />
            </div>
          </div>
          <div className={classes.flex}>
            <div className={classes.input}>
              <InputLabel className={classes.colorPickerLabel}>Confirm Buttons Text Color</InputLabel>
              <Field
                component={renderColorPicker}
                label="Confirm Buttons Text Color"
                name="confirmButtonsTextColor"
                validate={[ required ]}
                placeholder="e.g. #e90e0e"
              />
            </div>
            <div className={classes.input}>
              <InputLabel className={classes.colorPickerLabel}>Confirm Buttons Color</InputLabel>
              <Field
                component={renderColorPicker}
                label="Confirm Buttons Color"
                name="confirmButtonsColor"
                validate={[ required ]}
                placeholder="e.g. #e90e0e"
              />
            </div>
          </div>
          <div className={classes.flex}>
            <div className={classes.input}>
              <InputLabel>Font Style</InputLabel>
              <div className="control">
                <Field name="fontFamily" component={renderSelectField}>
                  {/*<option disabled value="">Please Select a font</option>*/}
                  <option value="Arial Black">Arial Black</option>
                  <option value="Arial">Arial</option>
                  <option value="Bookman">Bookman</option>
                  <option value="Comic Sans MS">Comic Sans MS</option>
                  <option value="Courier New">Courier New</option>
                  <option value="Courier">Courier</option>
                  <option value="Garamond">Garamond</option>
                  <option value="Georgia">Georgia</option>
                  <option value="Helvetica">Helvetica</option>
                  <option value="Impact">Impact</option>
                  <option value="Palatino">Palatino</option>
                  <option value="Times New Roman">Times New Roman</option>
                  <option value="Times">Times</option>
                  <option value="Trebuchet MS">Trebuchet MS</option>
                  <option value="Verdana">Verdana</option>
                </Field>
              </div>
            </div>
          </div>
          <CampaignUploadInput />

          <div className="field is-grouped" style={{marginTop: 20}}>
            <div className="control">
              <Link to="/campaigns">
                <Button variant="outlined">
                  Back to campaigns
                </Button>
              </Link>
            </div>
            <div className="control">
              <Button
                type="submit"
                disabled={pristine || submitting}
                color="primary"
                variant="contained"
              >
                Save
              </Button>
            </div>
          </div>
        </form>
      </CardContent>
    </Card>
  );
};


const renderOneOffPayments = ({ fields, meta: { touched, error }, classes, oneOffPayments }) => {
  return (
    <div>
      <div className={classNames(classes.flex, classes.giftBtn, classes.inputMargin)}>
        <Typography variant="body2">One Off Payment Options (4 max)</Typography>
        <Button 
          color="primary" 
          variant="contained"
          onClick={() => fields.push({})}
          disabled={fields.length === 4}
        >
          ADD PAYMENT OPTION
        </Button>
      </div>
      {fields.map((payment, index) =>
        <div key={`one-off-payment-${index}`} className={classes.paymentCard} >
          <div className={classNames(classes.flex)}>
            <Typography variant="body1">One Off Payment #{index + 1}</Typography>
            <CancelIcon 
                onClick={() => fields.remove(index)}
                color="error"
                className="is-pulled-right cursor-pointer"
              />
          </div>
          <Field
            component={renderField}
            type="number"
            placeholder="e.g. Payment amount: 25"
            name={`${payment}.figure`}
            label="Payment Figure"
            className={classes.inputMargin}
          />
          <Field
            component={renderField}
            type="text"
            placeholder="e.g. This donation helps ..."
            name={`${payment}.impact`}
            label="Payment Impact"
            inputProps={{
              maxLength: 120
            }}
            FormHelperTextProps={{
              style: {textAlign: 'right'}
            }}
            helperText={`${oneOffPayments && oneOffPayments[index] && oneOffPayments[index].impact && oneOffPayments[index].impact.length || 0} / 120`}
            className={classes.inputMargin}
          />
          <Field
            component={renderField}
            type="text"
            placeholder="e.g. url of the image"
            name={`${payment}.image`}
            label="Payment Image URL"
            className={classes.inputMargin}
          />
        </div>
      )}
    </div>
  )
};
const renderMonthlyPayments = ({ fields, meta: { touched, error }, classes, monthlyPayments }) => {
  return (
    <div>
      <div className={classNames(classes.flex, classes.giftBtn, classes.inputMargin)}>
        <Typography variant="body2">Monthly Payment Options (4 max)</Typography>
        <Button 
          color="primary" 
          variant="contained"
          onClick={() => fields.push({})}
          disabled={fields.length === 4}
        >
          ADD PAYMENT OPTION
        </Button>
      </div>
      {fields.map((payment, index) =>
        <div key={`one-off-payment-${index}`} className={classes.paymentCard} >
          <div className={classNames(classes.flex)}>
          <Typography variant="body1">Monthly Payment #{index + 1}</Typography>
            <CancelIcon 
                onClick={() => fields.remove(index)}
                color="error"
                className="is-pulled-right cursor-pointer"
              />
          </div>
          <Field
            component={renderField}
            type="number"
            placeholder="e.g. Payment amount: 25"
            name={`${payment}.figure`}
            label="Payment Figure"
            className={classes.inputMargin}
          />
          <Field
            component={renderField}
            type="text"
            placeholder="e.g. This donation helps ..."
            name={`${payment}.impact`}
            label="Payment Impact"
            inputProps={{
              maxLength: 120
            }}
            FormHelperTextProps={{
              style: {textAlign: 'right'}
            }}
            helperText={`${monthlyPayments && monthlyPayments[index] && monthlyPayments[index].impact && monthlyPayments[index].impact.length || 0} / 120`}
            className={classes.inputMargin}
          />
          <Field
            component={renderField}
            type="text"
            placeholder="e.g. url of the image"
            name={`${payment}.image`}
            label="Payment Image URL"
            className={classes.inputMargin}
          />
        </div>
      )}
    </div>
  )
};

const renderSidePanelFacts = ({fields, meta: {touched, error}, classes, sidePanelFooter, sidePanelFacts}) => {
  return (
    <section className={`section  ${classNames(classes.inputMargin, classes.panelBg)}`}>
      <div>
        <h4 className="subtitle">Side Panel Facts </h4>
        <div >
          <div>
            <Button
              color="primary"
              variant="contained"
              onClick={() => fields.push({})}
              disabled={fields.length === 3}
            >
              Add Fact
            </Button>
            {touched && error && <span>{error}</span>}
            <hr/>
          </div>
          {fields.map((fact, index) =>
            <div key={`side-panel-fact-${index}`}>
              <h5 className="subtitle">Fact #{index + 1}</h5>
              <CancelIcon 
                onClick={() => fields.remove(index)}
                color="error"
                className="is-pulled-right cursor-pointer"
              />
              <label className="label">Fact Figure</label>
              <div className="control">
                <Field
                  component={renderField}
                  type="text"
                  placeholder="Fact amount"
                  label="Fact amount"
                  name={`${fact}.figure`}
                />
              </div>
              <label className={`label ${classes.paddingTop}`}>Figure Impact</label>
              <div className="control" style={{paddingBottom: 30}}>
                <Field
                  component={renderField}
                  type="text"
                  placeholder="Fact description"
                  label="Fact description"
                  name={`${fact}.description`}
                  inputProps={{
                    maxLength: 70
                  }}
                  FormHelperTextProps={{
                    style: {textAlign: 'right'}
                  }}
                  helperText={`${sidePanelFacts && sidePanelFacts[index] && sidePanelFacts[index].description && sidePanelFacts[index].description.length || 0} / 70`}
                />
              </div>
              {/* <hr/> */}
            </div>
          )}
          <label className="label">Side Panel Footer</label>
          <div className="control">
            <Field
              component={renderField}
              type="text"
              placeholder="Side Panel Footer"
              name="sidePanelFooter"
              inputProps={{
                maxLength: 100
              }}
              FormHelperTextProps={{
                style: {textAlign: 'right'}
              }}
              helperText={`${sidePanelFooter && sidePanelFooter.length || 0} / 100`}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

const renderPollAnswers = ({fields, meta: {touched, error}, classes, pollAnswers}) => {
  return (
    <section className={`section  ${classNames(classes.inputMargin, classes.panelBg)}`}>
      <div>
        <h4 className="subtitle">Poll Answers</h4>
        <div >
          <div>
            <Button
              color="primary"
              variant="contained"
              onClick={() => fields.push({})}
              disabled={fields.length === 3}
            >
              Add Poll Answers
            </Button>
            {touched && error && <span>{error}</span>}
            <hr/>
          </div>
          {fields.map((answer, index) =>
            <div key={`side-panel-fact-${index}`}>
              <h5 className="subtitle">Answer #{index + 1}</h5>
              <CancelIcon 
                onClick={() => fields.remove(index)}
                color="error"
                className="is-pulled-right cursor-pointer"
              />
              <div className="control">
                <Field
                  component={renderField}
                  type="text"
                  placeholder="Enter Answer Text"
                  label="Answer Text"
                  name={`${answer}.text`}
                />
              </div>
              <div className={classes.input}>
                <FormControlLabel control={
                  <Field
                    name={`${answer}.isCorrect`}
                    component={renderField}
                    type="checkbox"
                  />}
                  label="Is correct"
                />
              </div>
              {/* <hr/> */}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};


let CampaignFormWithForm: any = reduxForm({
  form: 'campaign', // a unique identifier for this form
})(CampaignFormComponent);
const selector = formValueSelector('campaign') // <-- same as form name
CampaignFormWithForm = connect(state => {
    return {
      includeTarget: selector(state, 'includeTarget'),
      description: selector(state, 'description'),
      description2: selector(state, 'description2'),
      oneOffPayments: selector(state, 'oneOffPayments'),
      monthlyPayments: selector(state, 'monthlyPayments'),
      campaignType: selector(state, 'campaignType'),
      title: selector(state, 'title'),
      title2: selector(state, 'title2'),
      ctaText: selector(state, 'ctaText'),
      mission: selector(state, 'mission'),
      thankYouHeading: selector(state, 'thankYouHeading'),
      thankYouMessage: selector(state, 'thankYouMessage'),
      sidePanelFacts: selector(state, 'sidePanelFacts'),
      pollAnswerText: selector(state, 'pollAnswerText'),
      pollAnswers: selector(state, 'pollAnswers'),
      sidePanelFooter: selector(state, 'sidePanelFacts'),
      includePetitionTarget: selector(state, 'includePetitionTarget'),
      fundraisingPackConsentText: selector(state, 'fundraisingPackConsentText'),
      fundraisingPackSidePanelTitle: selector(state, 'fundraisingPackSidePanelTitle'),
      fundraisingPackSidePanelButtonText: selector(state, 'fundraisingPackSidePanelButtonText'),
      fundraisingPackConsentCheckboxText: selector(state, 'fundraisingPackConsentCheckboxText'),
      fundraisingPackConsentIsOptional: selector(state, 'fundraisingPackConsentIsOptional'),
      fontFamily: selector(state, 'fontFamily')
    }
  }
)(CampaignFormWithForm);

const mapStateToProps: any = ({ campaigns, auth }) => {

  if (campaigns && campaigns.currentlyEditingCampaign) {
    const { payment, charities } = campaigns.currentlyEditingCampaign;
    let monthly, oneOff;
    if (payment) {
      monthly = payment.monthly;
      oneOff = payment.oneOff;
    }
    let charity;
    for (let charityId in charities) {
      if(charities[charityId] === true) {
        charity = charityId;
        break;
      }
    }
    const oneOffPayments = map(oneOff, (value, figure) => ({ ...value, figure }));
    const monthlyPayments = map(monthly, (value, figure) => ({ ...value, figure }));
    const initialValues = { ...campaigns.currentlyEditingCampaign, oneOffPayments, monthlyPayments, charity };

    return {
      initialValues,
      auth
    };
  } else {
    return {auth};
  }

};

export const CampaignForm = connect(mapStateToProps)(withStyles(stylesMUI)(CampaignFormWithForm)) as any;
